import { useState } from 'react';

/**
 * usePathBuilding Hook - JavaScript Version
 * 
 * Manages state for custom path building functionality
 */
export const usePathBuilding = () => {
  const [customStartNode, setCustomStartNode] = useState(null);
  const [customEndNode, setCustomEndNode] = useState(null);
  const [customPath, setCustomPath] = useState([]);
  const [isBuildingPath, setIsBuildingPath] = useState(false);
  const [optimalPath, setOptimalPath] = useState([]);
  const [showOptimalPath, setShowOptimalPath] = useState(true);

  return {
    customStartNode,
    setCustomStartNode,
    customEndNode,
    setCustomEndNode,
    customPath,
    setCustomPath,
    isBuildingPath,
    setIsBuildingPath,
    optimalPath,
    setOptimalPath,
    showOptimalPath,
    setShowOptimalPath
  };
};
